/**
 * Japanese translations
 */

export default {
  GitHub: 'GitHub',
  'Repository hosting, code review, and collaboration': 'リポジトリのホスティング、コード レビュー、コラボレーション',
  'Build & Ship': 'ビルドとリリース',
  'CI/CD and automation': 'CI/CD と自動化',
  'Quality analysis, fixes, and enforcement': '品質分析、修正、基準の適用',
  Code: 'コーディング',
  'AI coding agent for tasks, projects and automated work':
    'タスク、プロジェクト、作業の自動化を支援する AI コーディング エージェント',
  'Cloud development environments': 'クラウド開発環境',
  Secure: '保護',
  'Vulnerability detection and remediation': '脆弱性の検出と修復',
  'Secret scanning and leak prevention': 'シークレット スキャンと漏洩防止',
  Learn: '学習',
  Certifications: '認定資格',
  Build: '開発',
  'Customize Copilot': 'Copilot のカスタマイズ',
  Explore: '検索',
  'Trending Repos': '人気のリポジトリ',
  Events: 'イベント',
  Businesses: 'ビジネス',
  'By Stage': '成長段階別',
  'Small & medium teams': '中小規模のチーム',
  'By Industry': '業種別',
  'See all industries': 'すべての業種を見る',
  'Evaluate GitHub': 'GitHub の導入を検討',
  'Add-ons': 'アドオン',
  'Learn & Connect': '学習と交流',
  'Resource Center': 'リソース センター',
  'Customer Support': 'カスタマー サポート',
  'About GitHub': 'GitHub について',
  'Enter your email': 'メールアドレスを入力',
  'Not included': '含まれていない',
  'Pause video': '動画を一時停止する',
  'Play video': '動画を再生する',
  'Pricing plans': '料金プラン',
  'Select an option': 'オプションを選択する',
  'Sign up for GitHub': 'GitHub にサインアップする',
  Country: '国',
  'The following fields have errors:': '次の項目にエラーがあります:',
  'You have the right to refuse the collection and use of your personal information, use of personal information or marketing purposes, and receiving marketing information as set forth above. However, if you refuse, you may not be able to receive the benefits described under Purpose of Collection & Use.':
    '上記に記載された個人情報の収集および利用、マーケティング目的での個人情報の利用、マーケティング情報の受信を拒否する権利があります。ただし、拒否した場合、収集および利用目的に記載された特典を受けられない場合があります。',
  'I agree to the collection and use of my personal information (required)*.':
    '個人情報の収集および利用に同意します（必須）*。',
  'Items of Personal Information to be Collected: {fields}, and any other fields visible on this form.':
    '収集される個人情報: {fields}、およびこのフォームに表示されているその他の項目。',
  'Purpose of Collection and Use: GitHub will use the data for the purpose described on this form.':
    '収集および利用目的: GitHubはこのフォームに記載された目的でデータを使用します。',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting':
    '個人情報の保持/利用期間: ご要望のサービスを提供するために必要な期間',
  'I agree to receiving marketing information and use of my personal information for marketing purposes (optional).':
    'マーケティング情報の受信およびマーケティング目的での個人情報の利用に同意します（任意）。',
  'Consent to Receive Marketing: The information collected may be used for GitHub for personalized communications, targeted advertising and campaign effectiveness.':
    'マーケティング受信の同意: 収集された情報は、GitHubによるパーソナライズされたコミュニケーション、ターゲット広告、キャンペーン効果のために使用される場合があります。',
  'Purpose of Collection and Use: To contact you for marketing purposes.':
    '収集および利用目的: マーケティング目的でご連絡するため。',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting.':
    '個人情報の保持/利用期間: ご要望のサービスを提供するために必要な期間。',
  'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the':
    'はい、お願いします。GitHub とその関連会社が個人情報をパーソナライズされたコミュニケーション、ターゲット広告およびキャンペーンの有効性のために使用しても構いません。詳細については、',
  'for more details.': 'をご覧ください。',
  'Participation requires transferring your personal data to other countries in which GitHub operates, including the United States. By submitting this form, you agree to the transfer of your data outside of China.':
    '参加には、米国を含むGitHubが運営する他の国への個人データの転送が必要です。このフォームを送信することで、中国国外へのデータ転送に同意したことになります。',
  'I will receive personalized communications and targeted advertising from GitHub and affiliates. See the':
    '私はGitHubおよび関連会社からパーソナライズされたコミュニケーションとターゲット広告を受け取ります。詳細は',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'はい、GitHubおよび関連会社からメールでパーソナライズされたコミュニケーション、ターゲット広告、キャンペーン効果に関する情報を受け取りたいです。 同意を撤回するか、連絡先設定を管理するには、次をご覧ください。',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email and phone for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'はい、GitHubおよび関連会社からメールと電話でパーソナライズされたコミュニケーション、ターゲット広告、キャンペーン効果に関する情報を受け取りたいです。 同意を撤回するか、連絡先設定を管理するには、次をご覧ください。',
  'Promotional Communications Manager': 'プロモーションコミュニケーションマネージャー',
  'GitHub Privacy Statement': 'GitHub Privacy Statement',
  'first name': '名',
  'last name': '姓',
  company: '会社',
  email: 'メール',
  'This field is required.': 'この項目は必須です。',
  'Please enter a valid value.': '有効な値を入力してください。',
  'Please enter a valid work email address.': '有効な勤務先メールアドレスを入力してください。',
  'The email is from a personal email provider.': 'メールが個人用プロバイダーのものです。',
  'Please enter a valid email address.': '有効なメールアドレスを入力してください。',
  'Please enter a valid phone number.': '有効な電話番号を入力してください。',
  'Please select your country/region': '国/地域を選択してください。',
  'Please complete the CAPTCHA.': 'CAPTCHAを完了してください。',
  'Choose your country/region': '国/地域を選択してください。',
  Included: '含まれている',
  Refresh: '更新',
  Unlimited: '無制限',
  'Learn more': '詳細を学ぶ',
  'Dev Days are here! Join an in-person event near you to learn more about the GitHub Copilot app and Copilot CLI with your community.':
    'Dev Days がやって来ました。今すぐ登録して、あなたの地域で対面イベントを開催し、コミュニティに GitHub Copilot アプリと Copilot CLI を紹介しましょう。',
  'Sort by:': '並び替え:',
  'Selecting a sort option will reload the page.': '並び替えオプションを選択するとページが再読み込みされます。',
  'Sort options': '並び替えオプション',
  Sort: '並び替え',
  Newest: '新しい順',
  Oldest: '古い順',
  Whitepapers: 'ホワイト ペーパー',
  Whitepaper: 'ホワイト ペーパー',
  Ebooks: 'eBook',
  AI: 'AI',
  Cloud: 'クラウド',
  DevOps: 'DevOps',
  'GitHub Actions': 'GitHub Actions',
  'GitHub Advanced Security': 'GitHub Advanced Security',
  'GitHub Enterprise': 'GitHub Enterprise',
  Innersource: 'インナーソース',
  'Open Source': 'オープン ソース',
  Security: 'セキュリティ',
  'Software Development': 'ソフトウェア開発',
  'Explore other resources': '他のリソースを確認',
  Share: 'シェア',
  'Ebooks & Whitepapers': 'eBook とホワイト ペーパー',
  Tags: 'タグ',
  Ebook: 'eBook',
  Platform: 'プラットフォーム',
  'AI CODE CREATION': 'AI コード作成',
  'GitHub Copilot': 'GitHub Copilot',
  'Write better code with AI': 'AI を使ってより優れたコードを記述する',
  'GitHub Copilot app': 'GitHub Copilot アプリ',
  'Direct agents from issue to merge': 'Issue も Merge もエージェントが直接実行',
  'GitHub Spark': 'GitHub Spark',
  'Build and deploy intelligent apps': 'インテリジェントなアプリケーションの構築とデプロイ',
  'GitHub Models': 'GitHub Models',
  'Manage and compare prompts': 'プロンプトの管理と比較',
  'MCP Registry (New)': 'MCP レジストリ (新機能)',
  'Integrate external tools': '外部ツールを統合',
  'View all features': 'すべての機能を表示',
  'DEVELOPER WORKFLOWS': '開発者ワークフロー',
  Actions: 'GitHub Actions',
  'Automate any workflow': 'あらゆるワークフローを自動化',
  Codespaces: 'Codespaces',
  'Instant dev environments': 'インスタント開発環境',
  Issues: 'Issues',
  'Plan and track work': '作業を計画し、追跡する',
  'Code review': 'コードレビュー',
  'Manage code changes': 'コード変更を管理する',
  'APPLICATION SECURITY': 'アプリケーション セキュリティ',
  'Find and fix vulnerabilities': '脆弱性を見つけて修復する',
  'Code Security': 'Code Security',
  'Secure your code as you build': 'セキュアにコードを構築',
  'Secret Protection': 'Secret Protection',
  'Stop leaks before they start': '発生する前に漏洩を阻止',
  EXPLORE: '検索',
  'Why GitHub': 'GitHub を使用する理由',
  Documentation: 'ドキュメント',
  Blog: 'ブログ',
  Changelog: 'Changelog',
  'GitHub Marketplace': 'GitHub Marketplace',
  Solutions: 'ソリューション',
  'BY COMPANY SIZE': '企業規模別',
  Enterprises: 'エンタープライズ',
  'Small and medium teams': '中小規模のチーム',
  Startups: 'スタートアップ',
  Nonprofits: '非営利',
  'View all solutions': '全てのソリューションを見る',
  'BY USE CASE': 'ユースケース別',
  'App modernization': 'アプリケーションのモダナイゼーション',
  DevSecOps: 'DevSecOps',
  'View all use cases': 'すべてのユース ケースを見る',
  'BY INDUSTRY': '業種別',
  Healthcare: 'ヘルスケア',
  'Financial services': '金融サービス',
  Manufacturing: '製造業',
  Government: '政府',
  'View all industries': 'すべての業種を見る',
  Resources: 'リソース',
  'EXPLORE BY TOPIC': 'トピック別に検索',
  'Software development': 'ソフトウェア開発',
  'View all topics': 'すべてのトピックを表示する',
  'EXPLORE BY TYPE': 'タイプ別に検索',
  'Customer stories': 'お客様の事例',
  'Events & webinars': 'イベントとウェビナー',
  'Ebooks & reports': 'eBook とレポート',
  'Business insights': 'ビジネスインサイト',
  'GitHub Skills': 'GitHub Skills',
  'SUPPORT & SERVICES': 'サポートとサービス',
  'Customer support': 'カスタマー サポート',
  'Community forum': 'コミュニティフォーラム',
  'Trust Center': 'Github Copilot Trust Center',
  Partners: 'パートナー',
  COMMUNITY: 'コミュニティ',
  'GitHub Sponsors': 'GitHub Sponsors',
  'Fund open source developers': 'オープン ソース開発者に資金援助を行う',
  'The ReadME Project': 'ReadME プロジェクト',
  'GitHub community articles': 'GitHub コミュニティの記事',
  'COMMUNITY PROGRAMS': 'コミュニティ プログラム',
  'Security Lab': 'Security Lab',
  'Maintainer Community': 'メンテナー コミュニティ',
  Accelerator: 'GitHub Accelerator',
  'Archive Program': 'GitHub Archive Program',
  REPOSITORIES: 'リポジトリ',
  Topics: 'トピックス',
  Trending: 'トレンド',
  Collections: 'コレクション',
  Enterprise: 'Enterprise',
  'ENTERPRISE SOLUTIONS': 'Enterprise ソリューション',
  'Enterprise platform': 'Enterprise プラットフォーム',
  'AI-powered developer platform': 'AI が支援する開発者向けプラットフォーム',
  'AVAILABLE ADD-ONS': 'アドオンとして利用可能',
  'Enterprise-grade application security': 'Enterprise グレードのアプリケーション セキュリティ',
  'Copilot for Business': 'ビジネス向け GitHub Copilot',
  'Enterprise-grade AI features': 'Enterprise グレードの AI 機能',
  'Premium Support': 'プレミアム サポート',
  'Enterprise-grade 24/7 support': 'Enterprise グレードのサポート (年中無休)',
  New: '新機能',
  Select: '選択します',
  'Install with script': 'script でインストール',
  'Install with npm': 'npm でインストール',
  'Install with Homebrew': 'Homebrew でインストール',
  'Install with WinGet': 'WinGet でインストール',
  Copy: 'コピーする',
  'Copy installation command': 'インストールのコマンドをコピー',
  'Copied to clipboard': 'クリップボードにコピー',
  'Send me a download link': 'ダウンロード リンクを自分に送信',
  'Download link copied.': 'ダウンロード リンクをコピーしました。',
  Copied: 'コピーしました',
  'Copy download link': 'ダウンロード リンクをコピー',
  "This browser doesn't support sharing. Copy the download link instead.":
    'このブラウザーでは共有がサポートされていません。代わりにダウンロード リンクをコピーしてください。',
  "We couldn't share the download link. Copy it instead.":
    'ダウンロード リンクを共有できませんでした。代わりにコピーしてください。',
  "This browser doesn't support copying. Copy the current page URL from the address bar instead.":
    'このブラウザーではコピーがサポートされていません。代わりにアドレス バーから現在のページの URL をコピーしてください。',
  "We couldn't copy the download link. Copy the current page URL from the address bar instead.":
    'ダウンロード リンクをコピーできませんでした。代わりにアドレス バーから現在のページの URL をコピーしてください。',
  'The download link is invalid. Please try again later.':
    'ダウンロード リンクが無効です。後でもう一度お試しください。',
  "We couldn't copy the download link. Copy the link below instead.":
    'ダウンロード リンクをコピーできませんでした。代わりに以下のリンクをコピーしてください。',
  "This browser doesn't support copying. Copy the link below instead.":
    'このブラウザーではコピーがサポートされていません。代わりに以下のリンクをコピーしてください。',
  'Select install method': 'インストール方法を選択',
  'Get Copilot CLI': 'GitHub Copilot CLI を入手する',
  'Read the documentation.': 'ドキュメントを読む。',
  'Included in Copilot Free, Pro, Pro+, Business, and Enterprise subscriptions.':
    'GitHub Copilot Free、Pro、Pro+、Business、Enterprise の各プランから利用可能。',
  'Included in Copilot Free, Pro, Pro+, Max, Business, and Enterprise subscriptions.':
    'GitHub Copilot Free、Pro、Pro+、Max、Business、Enterprise の各プランから利用可能。',
  'Available with Copilot Free, Pro, Pro+, Business, and Enterprise.':
    'GitHub Copilot Free、Pro、Pro+、Business、Enterprise で利用可能。',
  'Available with Copilot Free, Pro, Pro+, Max, Business, and Enterprise.':
    'GitHub Copilot Free、Pro、Pro+、Max、Business、Enterprise で利用可能。',
  'View all resources': 'すべてのリソースを見る',
  'Enterprise-grade security features': 'Enterprise グレードのセキュリティ 機能',
  Pricing: '料金',
  'Select country for phone number. Currently selected:': '電話番号の国を選択してください。現在の選択:',
  'Search countries': '国を検索',
  'Search countries...': '国を検索...',
  Countries: '国',
  'No countries found': '国が見つかりません',
  '{count} result available': '{count} 件の結果があります',
  '{count} results available': '{count} 件の結果があります',
  'Get the ebook': 'e ブックを入手',
  'Get the analysis': '分析を取得する',

  // Marketing navigation and footer
  Products: '製品',
  'GitHub Platform': 'GitHub Platform',
  Copilot: 'GitHub Copilot',
  'All Features': 'すべての機能',
  Developers: '開発者',
  'GitHub CLI': 'GitHub CLI',
  'GitHub Desktop': 'GitHub Desktop',
  'GitHub Mobile': 'GitHub Mobile',
  Integrations: 'インテグレーション',
  'MCP Registry': 'MCP レジストリ',
  Training: 'トレーニング',
  'Build with Copilot': 'GitHub Copilot で構築する',
  'GitHub Status': 'GitHub ステータス',

  // Marketing footer
  Subscribe: 'サブスクライブ',
  Ecosystem: 'エコシステム',
  Support: 'サポート',
  Company: '会社',
  Features: '機能',
  Team: 'Team',
  Roadmap: 'ロードマップ',
  'Compare GitHub': 'GitHub を比較する',
  'Developer API': '開発者 API',
  Education: '教育',
  Docs: 'ドキュメント',
  'Community Forum': 'コミュニティフォーラム',
  'Professional Services': 'プロフェッショナルサービス',
  Skills: 'スキル',
  Status: '状況',
  'Contact GitHub': 'GitHub へのお問い合わせ',
  About: 'GitHub について',
  Careers: 'キャリア',
  Newsroom: 'ニュースルーム',
  Inclusion: '包括性',
  'Social Impact': 'ソーシャルインパクト',
  Shop: 'ショップ',
  'What is Git?': 'Git とは何ですか?',
  Sitemap: 'サイトマップ',
  Terms: '規約',
  Privacy: 'プライバシー',
  'Manage cookies': 'Cookies を管理する',
  'Do not share my personal information': '個人情報の共有を禁止する',

  // Marketing footer — newsletter heading/description reuse legacy copy (pending loc review)
  'The developer newsletter': '開発者ニュースレターをサブスクライブする',
  'Get tips, technical guides, and best practices. Twice a month. Right in your inbox.':
    'ヒント、テクニカルガイド、ベストプラクティスを受け取りましょう。毎月 2 回、受信ボックスに直接配信されます。',
  'Customer Stories': 'お客様の事例',

  // Marketing footer — a11y/nav and social labels (drafted, pending loc verification)
  'Go to GitHub homepage': 'GitHub のホームページに移動',
  'Site-wide Links': 'サイト全体のリンク',
  'Legal and Resource Links': '法的情報とリソースのリンク',
  "GitHub's Social Media Links": 'GitHub のソーシャルメディアのリンク',
  'Select language': '言語を選択',
  'GitHub on LinkedIn': 'LinkedIn の GitHub',
  'GitHub on Instagram': 'Instagram の GitHub',
  'GitHub on YouTube': 'YouTube の GitHub',
  'GitHub on X': 'X の GitHub',
  'GitHub on TikTok': 'TikTok の GitHub',
  'GitHub on Twitch': 'Twitch の GitHub',
  'GitHub’s organization on GitHub': 'GitHub 上の GitHub 組織',

  // Article page table of contents
  'Table of contents': '目次',
  'Open table of contents': '目次を開く',
  'Close table of contents': '目次を閉じる',
  'Code Quality': 'Code Quality',
  'Enforce quality at merge': 'マージ時にコードの品質を向上',
  // EmailCaptureForm
  'Email address': 'メールアドレス',
  'Email capture form': 'メールアドレス登録フォーム',
  'Submitting your email address…': 'メールアドレスを送信しています…',
  'Thanks! Your email address has been submitted.': 'ありがとうございます。メールアドレスを送信しました。',
  'Something went wrong. Please try again.': '問題が発生しました。もう一度お試しください。',
  'More information about {feature}': '{feature}の詳細情報',
  'More information about this feature': 'この機能の詳細情報',
  // Add more translations here
}
